import { Box, Button, Modal } from "@mui/material";
import React from "react";

const ViewBills = ({ isOpen, handleClose, data }) => {
  console.log("data", data);
  return (
    <>
      <Modal open={isOpen} onClose={handleClose}>
        <Box
          sx={{
            width: "60%",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "#fff",
            border: "none",
            boxShadow: 24,
            p: "2rem",
            textAlign: "left",
            letterSpacing: 1,
            borderRadius: "8px",
            maxHeight: "80vh",
            overflowY: "auto",
          }}
        >
          <div
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            <p
              style={{
                fontFamily: "Inter",
                fontSize: "20px",
                fontWeight: "600",
                lineHeight: "24px",
                textAlign: "center",
                marginBottom: "1rem",
                // padding: "1rem 0",
              }}
            >
              {data?._id} Bills
            </p>

            {data?.reimbursements?.map((d) => (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  backgroundColor: "#FCFCFC",
                  border: "1px solid rgba(225, 225, 225, 0.25)",
                  padding: "10px 15px",
                  borderRadius: "20px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "5px",
                    flexDirection: "column",
                  }}
                >
                  <p>{d?.SAP_ID}</p>
                  <div style={{ display: "flex" }}>
                    <p
                      style={{
                        fontSize: "12px",
                        height: "24px",
                        padding: "5px 15px",
                        borderRadius: "16px",
                        backgroundColor: `rgba(233, 181, 33, 0.1)`,
                      }}
                    >
                      {d?.category}
                    </p>
                    <p
                      style={{
                        fontSize: "12px",
                        height: "26px",
                        padding: "5px 15px",
                        borderRadius: "16px",
                        backgroundColor: `rgba(64, 175, 115, 0.1)`,
                        marginLeft: "1rem",
                      }}
                    >
                      {d?.subCategory}
                    </p>
                  </div>

                  {d?.status === "Rejected" ? (
                    <p
                      style={{
                        fontFamily: "Poppins",
                        fontSize: "14px",
                        fontWeight: "400",
                        color: "#565A6D",
                        marginTop: "5px",
                      }}
                    >
                      {d?.rejectReason}
                    </p>
                  ) : null}
                </div>
                <div>
                  <p
                    style={{
                      fontFamily: "Poppins",
                      fontSize: "16px",
                      fontWeight: "600",
                      color: "#0E132F",
                      marginTop: "5px",
                    }}
                  >
                    ₹ {d?.amount}
                  </p>
                </div>
              </div>
            ))}

            <Button
              variant="outlined"
              onClick={handleClose}
              style={{ width: "200px", marginLeft: "auto", marginTop: "1rem" }}
            >
              Cancel
            </Button>
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default ViewBills;
